"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserAchievementEnum = void 0;
/**
 * Достижения пользователя
 */
var UserAchievementEnum;
(function (UserAchievementEnum) {
  /** хотя бы однажды указал имя */
  UserAchievementEnum[UserAchievementEnum["username"] = 1] = "username";
  /** хотя бы однажды указал аватар */
  UserAchievementEnum[UserAchievementEnum["userpic"] = 2] = "userpic";
  /** хотя бы однажды был верифицирован как преподаватель */
  UserAchievementEnum[UserAchievementEnum["verified_as_teacher_once"] = 3] = "verified_as_teacher_once";
  /** хотя бы однажды создавал услугу */
  UserAchievementEnum[UserAchievementEnum["created_user_services_once"] = 14] = "created_user_services_once";
  /** хотя бы однажды публиковал услугу */
  UserAchievementEnum[UserAchievementEnum["published_user_services_once"] = 4] = "published_user_services_once";
  /** хотя бы однажды услуга была одобрена для библиотеки */
  UserAchievementEnum[UserAchievementEnum["approved_user_services_once"] = 15] = "approved_user_services_once";
  /** хотя бы однажды указывал рабочее время в календаре */
  UserAchievementEnum[UserAchievementEnum["added_working_time_once"] = 5] = "added_working_time_once";
  /** хотя бы однажды указал всю информацию по биллингу */
  UserAchievementEnum[UserAchievementEnum["billing_ok_once"] = 6] = "billing_ok_once";
  /* хотя бы раз создал контент */
  UserAchievementEnum[UserAchievementEnum["created_content_once"] = 7] = "created_content_once";
  /* хотя бы раз публиковал контент */
  UserAchievementEnum[UserAchievementEnum["published_content_once"] = 8] = "published_content_once";
  /* хотя бы раз контент был одобрен для библиотеки */
  UserAchievementEnum[UserAchievementEnum["approved_content_once"] = 9] = "approved_content_once";
  /* хотя бы раз создал коллекцию */
  UserAchievementEnum[UserAchievementEnum["created_collection_once"] = 10] = "created_collection_once";
  /* хотя бы раз публиковал коллекцию */
  UserAchievementEnum[UserAchievementEnum["published_collection_once"] = 11] = "published_collection_once";
  /* хотя бы раз коллекция была одобрена для библиотеки */
  UserAchievementEnum[UserAchievementEnum["approved_collection_once"] = 12] = "approved_collection_once";
  /* хотя бы раз коллекция была куплена */
  UserAchievementEnum[UserAchievementEnum["sold_collection_on\u0441e"] = 13] = "sold_collection_on\u0441e";
  // NOTE: для добавления пунктов - следующий пункт
  // : 16
})(UserAchievementEnum = exports.UserAchievementEnum || (exports.UserAchievementEnum = {}));
